<ts-analysis-task-editor [task]="data.analysisTask" (submitted)="close($event)"> </ts-analysis-task-editor>
